/**
 *
 */

import { StatusName, StatusQueueName } from "./user";
import { StatusCampaignName } from "./campaign";
import {
    dateFormat,
    getHourFormat,
    secondsToTimeFormat,
    HumanTimeFormat,
    secondsToHumanTimeFormat
} from "./dateFormat";

// crear plugin vue

export default {
    install(Vue) {
        Vue.filter("StatusName", StatusName);
        Vue.filter("StatusQueueName", StatusQueueName);
        Vue.filter("StatusCampaignName", StatusCampaignName);
        Vue.filter("dateFormat", dateFormat);
        Vue.filter("getHourFormat", getHourFormat);
        Vue.filter("secondsToTimeFormat", secondsToTimeFormat);
        Vue.filter("HumanTimeFormat", HumanTimeFormat);
        Vue.filter("secondsToHumanTimeFormat", secondsToHumanTimeFormat);
    }
};
